export const enum FsAuthDigest {
  MD5 = 'md5',
  SHA256 = 'sha-256',
}
